import { ThemeEvents } from '@theme/events';

/**
 * Finds which position in a variant's `options` array holds a screen-size-like
 * value (e.g. "50 Zoll"), rather than assuming option position 1 is always size.
 * Falls back to the only option when a product has just one.
 * @param {string[]} options
 * @returns {number} index, or -1 if none found
 */
function findSizeIndex(options) {
  if (!Array.isArray(options)) return -1;
  for (let i = 0; i < options.length; i++) {
    if (/\d+(?:[.,]\d+)?\s*(zoll|cm|"|inch|in\.)/i.test(String(options[i]))) return i;
  }
  return options.length === 1 ? 0 : -1;
}

/**
 * Keeps the PDP's H1 in sync with the selected size variant after the initial
 * render (handled separately, synchronously, by an inline script in
 * blocks/_product-details.liquid to avoid a flash of the un-sized title).
 *
 * Reuses `event.detail.resource` from the existing VariantUpdateEvent - no
 * additional network fetch is needed since the variant's option values are
 * already present on that event.
 * @param {CustomEvent} event
 */
function updateTitle(event) {
  const h1 = document.querySelector('[class*="__title_text"] h1');
  if (!h1) return;

  const { titlePrefix: prefix, titleSuffix: suffix } = h1.dataset;
  // Undefined means the initial inline sync found no size-like option on this
  // product and intentionally left the title untouched - stay consistent.
  if (prefix === undefined) return;

  const options = event.detail.resource?.options;
  const sizeIndex = findSizeIndex(options);
  if (sizeIndex === -1) return;

  const sizeValue = options[sizeIndex];
  if (!sizeValue) return;

  const alreadyIncluded = prefix.toLowerCase().includes(String(sizeValue).toLowerCase());

  if (alreadyIncluded) {
    h1.textContent = suffix ? `${prefix} ${suffix}` : prefix;
  } else {
    h1.textContent = suffix ? `${prefix} ${sizeValue} ${suffix}` : `${prefix} ${sizeValue}`;
  }
}

document.addEventListener(ThemeEvents.variantUpdate, updateTitle);
